<div class="carousel-container">
    <div class="carousel-track" [style.transform]="'translateX(' + (-currentSlide * 100) + '%)'">
        @for (item of items; track item) {
            <div class="carousel-slide">
                <img class="object-cover h-[350px] w-full" [src]="item?.image" alt="{{ item?.title }}" />
                <p class="slide-title">{{ item?.title }}</p>
            </div>
        }
    </div>

    <div class="carousel-buttons">
        <button mat-icon-button (click)="prevSlide()">
            <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
        <button mat-icon-button (click)="nextSlide()">
            <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
    </div>
</div>
